
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const improveHabits = useStore((state) => state.improveHabits);
  const setImproveHabits = useStore((state) => state.setImproveHabits);
  const [next, setNext] = useState(improveHabits.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setImproveHabits(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.improveHabits.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={improveHabits} onChange={handleChange}>
          <MultiOption value={'Make more mindful food choices'}>
            <span>🧠</span> {t('onboarding.improveHabits.options.choices')}
          </MultiOption>
          <MultiOption value={'Eat more fruits and veggies'}>
            <span>🥗</span> {t('onboarding.improveHabits.options.eat')}
          </MultiOption>
          <MultiOption value={'Drink more water'}>
            <span>💧</span> {t('onboarding.improveHabits.options.drink')}
          </MultiOption>
          <MultiOption value={'Learn more about nutrition and health'}>
            <span>📚</span> {t('onboarding.improveHabits.options.learn')}
          </MultiOption>
          <MultiOption value={'Pay attention to hunger and portion sizes'}>
            <span>🍽️</span> {t('onboarding.improveHabits.options.attention')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.improveHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'improve-habits',
              answer: improveHabits.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
